import { defineMessages } from 'react-intl';

export default defineMessages({
  preview: 'Preview popup',
  previewOn: 'Preview on website',
  copyLink: 'Copy link',
});
